import { SVGInterface } from "../../interface";

const InformationFilled = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.00001 12C2 17.5228 6.47715 22 12 22C17.5203 21.9939 21.9939 17.5203 22 12C22 6.47715 17.5229 2 12 2C6.47716 2 2.00001 6.47715 2.00001 12ZM13 17L11 17L11 10.9999L13 11L13 17ZM13 8.99995L11 8.99995L11 6.99995L13 6.99995L13 8.99995Z"
      fill={color || "#1C2B36"}
    />
  </svg>
);

export default InformationFilled;
